<template>
  <v-col cols="12" xl="4" lg="4" md="5" sm="8">
    <v-card style="padding: 20px;">
      <v-card-title>
        <h3>注册</h3>
      </v-card-title>
      <v-card-subtitle>
        <span>从此刻开始注册MAKjust账户</span>
      </v-card-subtitle>
      <v-card-text>
        <v-form v-model="valid">
          <v-text-field
            v-model="username"
            :rules="[rules.required, rules.userMax, rules.userText]"
            label="用户名"
            required
          ></v-text-field>
          <v-text-field
            v-model="email"
            :rules="[rules.required, rules.emailIs]"
            label="邮箱"
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            :append-icon="pwdShow ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.pwdMin]"
            :type="pwdShow ? 'text' : 'password'"
            label="密码"
            hint="请输入密码"
            counter
            @click:append="pwdShow = !pwdShow"
          ></v-text-field>
          <v-text-field
            v-model="confirmPwd"
            :append-icon="pwdShow ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.isp]"
            :type="pwdShow ? 'text' : 'password'"
            label="确认密码"
            hint="请确认您的密码"
            counter
            @click:append="pwdShow = !pwdShow"
          ></v-text-field>
        </v-form>
        <router-link to="login">返回登录</router-link>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" color="primary" style="padding: 0 42px;" @click="signup()">注册</v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import mjp from "@/plugins/makjust";

export default {
  name: "LOGIN_Window_v1",
  data() {
    return {
      valid: false,
      username: "",
      email: "",
      password: "",
      pwdShow: false,
      confirmPwd: "",
      rules: {
        required: value => !!value || "此项不能为空",
        userMax: v => v.length <= 10 || "用户名不能超过10个字符",
        userText: v =>
          /^[a-zA-Z0-9]+$/.test(v) || "用户名只能是英文与数字的结合",
        emailIs: v =>
          /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
            v
          ) || "这不是一个正确的电子邮箱",
        pwdMin: v => v.length >= 6 || "这最少应该是一个6位的密码",
        isp: v => v === this.password || "密码不一致"
      }
    };
  },
  methods: {
    signup() {
      mjp
        .signup(this.username, this.email, this.password)
        .then(r => {
          this.password = "";
          this.confirmPwd = "";
          this.$store.dispatch("saveUserAsync", {
            username: r.data.username,
            session: r.data,
            avatar: r.data.avatar,
            email: r.data.email
          });
          this.$store.commit("showSnackbar", {
            type: "success",
            text: "注册成功"
          });
          this.$store.commit("func_userReset"); //重新读取USER设置项
          this.$route.query.redirect
            ? this.$router.push(this.$route.query.redirect)
            : this.$router.push("/"); //跳转
          location.reload();
        })
        .catch(e => {
          if (e.response) {
            this.password = "";
            this.confirmPwd = "";
            this.$store.commit("showSnackbar", {
              type: "error",
              text:
                "[Code" +
                e.response.data.code +
                "]注册失败：" +
                e.response.data.error
            });
          }
        });
    }
  }
};
</script>